/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import { Stethoscope, UserRound, HeartPulse, Baby } from 'lucide-react';

// Preferenze NON sensibili del pannello dev (sequenze di impersonation): solo nomi e ruoli.
const CHAIN_STORAGE_KEY = 'sanitanexus.dev.impersonation_chains';

export const DEFAULT_CHAINS = [
  { id: 'preset-patient-book', name: 'Paziente → Prenota visita', steps: [{ role: 'patient' }], icon: '📅' },
  { id: 'preset-doctor-soap', name: 'Medico → Dettato SOAP', steps: [{ role: 'doctor' }], icon: '🎙️' },
  { id: 'preset-nurse-alert', name: 'Infermiere → Verifica alert IoT', steps: [{ role: 'nurse' }], icon: '🚨' },
  { id: 'preset-flow-triage', name: 'Full triage: Paziente → Medico → Firma', steps: [{ role: 'patient' }, { role: 'doctor' }, { role: 'admin' }], icon: '🔗' },
];

export const loadChains = () => {
  try {
    const raw = localStorage.getItem(CHAIN_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) && parsed.length ? parsed : DEFAULT_CHAINS;
  } catch { return DEFAULT_CHAINS; }
};

export const saveChains = (chains) => {
  try { localStorage.setItem(CHAIN_STORAGE_KEY, JSON.stringify(chains)); }
  catch { /* localStorage unavailable */ }
};

export const ROLE_OPTIONS = [
  { key: 'doctor', label: 'Medico', icon: Stethoscope, color: 'bg-blue-500/15 border-blue-500/40 text-blue-700 dark:text-blue-300' },
  { key: 'nurse', label: 'Infermiere', icon: HeartPulse, color: 'bg-pink-500/15 border-pink-500/40 text-pink-700 dark:text-pink-300' },
  { key: 'oss', label: 'OSS', icon: UserRound, color: 'bg-amber-500/15 border-amber-500/40 text-amber-700 dark:text-amber-300' },
  { key: 'patient', label: 'Paziente', icon: Baby, color: 'bg-emerald-500/15 border-emerald-500/40 text-emerald-700 dark:text-emerald-300' },
];

/** Ruolo di impersonation dedotto da un utente (per salvare la sequenza corrente). */
export const roleKeyForUser = (u) => (
  u?.category === 'paziente' ? 'patient'
    : u?.professional_role === 'nurse' ? 'nurse'
      : u?.professional_role === 'oss' ? 'oss'
        : u?.is_admin ? 'admin' : 'doctor'
);
